export const PRMCodes = [
    "WCHR",
    "WCHS",
    "WCHC",
    "BLND",
    "MEDA",
    "DEAF",
    "DPNA",
    "SVAN",
    "LNYD",
    "WCMP",
    "WCLB",
    "WCHP",
    "WCBW",
    "WCBD",
    "STCR",
    "PETC",
    "PPOC",
    "ESAN",
    "OXYG",
    "MAAS",
    "YPTA"
]

// Codes only offered in the assistance dropdown for specific airport authorities.
// Any code not listed here is available everywhere. Keeps airport-specific gating
// as config against the single source of truth (PRMCodes) rather than divergent lists.
export const AIRPORT_RESTRICTED_CODES = {
    LNYD: ["DUB"],
    PETC: ["BFS"],
}

export const sydneyAirlines = [
    { label: "ALL", value: "" },
    { label: "JQ", value: "JQ" },
    { label: "VA", value: "VA" },
    { label: "QF", value: "QF" },
    { label: "BA", value: "BA" },
    { label: "KE", value: "KE" },
    { label: "UA", value: "UA" },
    { label: "GA", value: "GA" },
    { label: "AC", value: "AC" },
    { label: "VN", value: "VN" },
    { label: "NH", value: "NH" },
    { label: "MH", value: "MH" },
    { label: "TG", value: "TG" },
    { label: "CI", value: "CI" },
    { label: "QR", value: "QR" },
    { label: "UL", value: "UL" },
    { label: "KE", value: "KE" }
]

export const ASSISTANCE_PRIORITY = ["WCHC", "WCHS", "WCHR"];


export const AIRPORTS_WITH_SITA = ["ORK", "BFS", "DUB"]

export const stripeKey = 'pk_live_51JZMhZKZM1vasB44SEcFRmU6DrlWO1KrrfsX0fcxduR1GQ093qS5I9gE9FbLr0xCDJEGjWgkRGvXvWVlq3bf4tgd005D7Pfai9'
export const TARGET_CODES = ['WCHR', 'WCHC', 'WCHS', 'BLND', 'DEAF']; // display set

//targets for reject reasons
export const DEFAULT_RR_TARGETS = ["ARRIVAL", "DEPARTURE", "BOARDING", "RAMP", "ALT", "PAX"];
//who can see these reasons
export const DEFAULT_RR_ELIGIBLE = ["APP", "PORTAL"];
//Static reason data as initial values like what was exist on server.
const STATIC_REJECT_REASONS = [
    "Pax did not show up",
    "Pax did not require assistance",
    "Chair assistance only",
];

//BFS-specific additional static reasons
const BFS_STATIC_REJECT_REASONS = [
    "Pax self-boarded",
    "Pax no longer travelling",
    "Pax no show",
    "Flight Cancelled",
];

// Helper to format reasons with default target and eligible
const formatStaticReasons = (reasons) => reasons.map((label, index) => ({
    label,
    // no `value` for static/new reasons — server will generate md5 if needed
    target: DEFAULT_RR_TARGETS,
    eligible: DEFAULT_RR_ELIGIBLE,
    _localId: `static_${index}_${label.replace(/\s+/g, '_')}`, // stable id based on index and label
}));

// Default static reasons (for non-BFS airports)
export const MOCK_REJECT_REASONS = formatStaticReasons(STATIC_REJECT_REASONS);

// BFS-specific static reasons (includes default + BFS additional)
export const BFS_MOCK_REJECT_REASONS = formatStaticReasons([...STATIC_REJECT_REASONS, ...BFS_STATIC_REJECT_REASONS]);

export const WHEELCHAIR_PRIORITY = ["WCHC", "WCHS", "WCLB", "WCMP", "WCHR"];

export const SESSION_MAX_DURATION_MS = (12 * 60 + 30) * 60 * 1000; // 12 hours 30 minutes absolute
// Heartbeat cadence. Must stay below the backend STALE_THRESHOLD_MS (15 min) with room for a
// couple of missed beats, so an active user is never swept by the stale-session cron. Keep in
// sync with HEARTBEAT_INTERVAL_MS in prmassist-backend/prm-users-mobile/crud/crud-sessions.js.
export const SESSION_HEARTBEAT_MS = 5 * 60 * 1000; // 5 minutes
export const TIMELINE_V2_AIRPORTS = ["PUJ", "DUB", "BFS", "SYD", "JER", "ORK", "MLA", "EDI", "SNN"];
export const AIRPORTS_SUPPORTS_SESSIONS = ['DUB'];

export const INCIDENT_TYPES = [{ label: 'Passenger Fall', value: 'passenger-fall' }, { label: 'Passenger Staff Incident', value: 'passenger-staff-incident' }, { label: 'Airline Incident', value: 'airline-incident' }, { label: 'Other', value: 'other' }];
